<template>
  <div>
    <el-dialog
      ref="upLoadPicture"
      class="uploadClass"
      width="800px"
      title="上传图片"
      @close="closeDigLog"
      :visible.sync="dialogClose"
      destroy-on-close
      v-if="dialogClose"
    >
      <!--      选择上传文件夹-->
      <div class="upload-select">
        <span>上传到:</span>
        <el-select
          ref="selectTree"
          v-model="value"
          placeholder="请选择"
          popper-class="popperTreeSelect"
          style="margin-left: 10px;"
        >
          <el-option :value="value" :label="value">
            <el-tree
              ref="tree"
              :load="loadNode"
              :props="defaultProps"
              lazy
              node-key="id"
              @node-click="handleNodeClick"
            >
              <span class="custom-tree-node" slot-scope="{ node }">
                <span>{{ node.label }}</span>
              </span>
            </el-tree>
          </el-option>
        </el-select>
      </div>
      <!--      上传组件-->
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="uploadUrl"
        :on-change="change"
        :on-error="handleAvatarError"
        :data="file"
        :on-remove="handleRemove"
        accept="image/jpeg,image/gif,image/png,image/jpg"
        :show-file-list="false"
        multiple
        :limit="100"
        :before-upload="beforeAvatarUpload"
        :on-exceed="handleExceed"
        :file-list="fileList"
        drag
      >
        <div>
          <el-button slot="trigger" size="medium " class="uploadButton"
            >上传</el-button
          >
          <div style="text-align: center;margin-top: 10px;">
            <span>将文件拖放到此窗口即可上传</span><br />
            <span>仅支持jpg， png， gif， jpeg文件格式， 大小不能超过5MB</span
            ><br />
            <span>仅支持批量上传最多100个图片文件</span>
          </div>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="default-mini" @click="dialogClose = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <!--    上传结果组件-->
    <uploadProgress
      ref="uploadProgress"
      :updateData="updateData"
      :value="value"
      :uploadOver="uploadOver"
      :failure="failure"
      :successPic="successPic"
      @closeDigLog="closeDigLog"
      @getFileList="getFileList"
    ></uploadProgress>
  </div>
</template>
<script>
import { addUrlPerFix } from "@/utils";
import uploadProgress from "./uploadProgress";
import { qryImageFile } from "./pictureManage";
export default {
  name: "upLoadPicture",
  components: {
    uploadProgress
  },
  computed: {
    uploadUrl: function() {
      return addUrlPerFix("sra.iccec.cn/apis/sra/spc/users/signup/image/uploadImageBatchByShopId");
    },
    agentId: function() {
      return '100029'  //getArgs("a");
    }
  },
  data() {
    return {
      file: {
        shopId: localStorage.getItem("shopId")
      },
      uploadOver: true, //判断上传结束
      dialogClose: false, //判断弹窗打开
      value: "", //文件夹名称
      fileList: [], //上传的文件列表
      updateData: [], //数组存放上传文件
      successPic: [], //存放成功文件
      failure: [], //存放失败文件
      defaultProps: {
        label: "fileName",
        isLeaf: "leaf"
      },
      NodeData: {},
      fileId: "",
      imgStauts: {
        isJPG: true,
        isLt5M: true,
        isName: true
      }
    };
  },
  methods: {
    // 上传失败调用
    handleAvatarError(res, file) {
      console.log(res, file, "res,file");
      this.$message({
        showClose: true,
        message: res.message,
        type: "error",
        ccuiCustom: true,
        duration: 3000
      });
    },
    //获取树结构
    loadNode(node, resolve) {
      let params = {
        parentId: node.level !== 0 ? node.data.fileId : 0,
        shopId: localStorage.getItem("shopId")
      };

      qryImageFile(params).then(res => {
        resolve(res.data.data);
        let uploadpictureData = JSON.parse(
          localStorage.getItem("uploadpicture")
        );
        if (uploadpictureData && uploadpictureData[this.agentId]) {
          let localPic = JSON.parse(localStorage.getItem("uploadpicture"))[
            this.agentId
          ];
          this.value = localPic.value;
          this.file = {
            fileId: localPic.fileid,
            shopId: localStorage.getItem("shopId"),
            agentId: this.agentId
          };
        } else if (this.value == "") {
          this.value = res.data.data[0].fileName;
          this.file = {
            fileId: String(res.data.data[0].fileId),
            shopId: localStorage.getItem("shopId"),
            agentId: this.agentId
          };
        }
      });
    },
    //上传结果弹窗关闭后 上传页面关闭
    closeDigLog() {
      this.$emit("refresh");
      this.value = "";
      this.dialogClose = false;
    },
    //获取子组件表格数据
    getFileList(tableData) {
      this.successPic = [];
      this.fileList = [];
      this.failure = [];
      this.updateData = tableData;
    },
    //上传状态
    change(file) {
      if (file.status == "fail") {
        this.updateData.map(res => {
          if (res.uid === file.uid) {
            res.isUppass = 2;
            res.status = "上传失败";
            this.failure.push({ status: "上传失败" });
          }
        });
        return;
      }
      if (this.updateData.length == 0) {
        this.$refs.uploadProgress.openProgress();
      }
      let pushFlag = true;
      this.uploadOver = true;
      this.updateData.map(res => {
        if (res.uid === file.uid) {
          res.value = this.value;
          res.isUppass = 2;
          res.status = file.response.data.uploadImageBatchRsp[0].state;
          res.size = file.response.data.uploadImageBatchRsp[0].imgSpace;
          res.picUrl =
            file.response.data.uploadImageBatchRsp[0].imgAddress.split("?")[0] +
            "?x-image-process=image/resize,m_lfit,h_100,w_100";
          pushFlag = false;
          if (res.status === "上传成功") {
            this.successPic.push({ status: "成功" });
          } else if (res.status === "上传失败") {
            this.failure.push({ status: "失败" });
          }
        }
        //判断是否全部上传完成 1为上传中 2为上传完毕
      });
      this.uploadOver = !this.updateData.every(res => res.isUppass == 2);
      if (pushFlag) {
        this.updateData.push({
          picUrl: require("@/assets/images/uploadPicture.png"),
          name: file.name,
          size: Math.floor((file.size / 1024) * 100) / 100 + "KB",
          type: file.raw.type,
          status: "上传中",
          value: this.value,
          uid: file.uid,
          isUppass: 1
        });
      }
    },
    //打开弹窗
    open() {
      localStorage.removeItem("uploadpicture");
      this.dialogClose = true;
    },
    //文件超出个数限制时调用
    handleExceed(files) {
      this.$message({
        showClose: true,
        message: `仅支持批量上传最多100个图片文件,本次选择了${files.length}个文件`,
        type: "error",
        ccuiCustom: true
      });
    },
    //文件移除时调用
    handleRemove(file) {
      this.updateData.map(res => {
        if (res.uid === file.uid) {
          res.isUppass = 2;
          res.status = "上传失败";
          this.failure.push({ status: "上传失败" });
        }
      });
    },
    //文件上传时限制格式类型，在上传结果列表调用，出现上传限制提示语
    beforeAvatarUpload(file) {
      this.$refs.uploadProgress.beforeAvatarUpload(file);
      const isJPG = [
        "image/jpeg",
        "image/gif",
        "image/png",
        "image/jpg"
      ].includes(file.type);
      const isLt5M = file.size / 1024 / 1024 < 5;
      const isName = file.name.length < 100;
      return isJPG && isLt5M && isName;
    },
    //点击树的节点
    handleNodeClick(data, node) {
      let NodeData = {};
      let obj = JSON.parse(localStorage.getItem("uploadpicture")) || {};
      console.log(node, "node");
      this.fileId = node.data.fileId;
      this.value = node.data.fileName;
      this.file = { fileId: node.data.fileId, agentId: this.agentId };
      NodeData = {
        fileid: this.fileId,
        value: this.value,
        agentId: this.agentId
      };
      obj[this.agentId] = NodeData;
      localStorage.setItem("uploadpicture", JSON.stringify(obj));
      this.$refs.selectTree.blur();
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.el-upload-dragger:hover {
  color: #4a4a4a !important;
}
/deep/.uploadClass .el-dialog__body {
  height: 420px;
}
/deep/.upload-demo {
  height: 85%;
  width: 100%;
}
.uploadButton {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #0089ef;
  line-height: 28px;
  font-weight: 400;
  height: 60px;
  border-radius: 4px;
  width: 300px;
  border: 1px solid #0089ef;
}
.upload-demo /deep/.el-button:focus {
  background: white;
}
.upload-demo /deep/.el-button:hover {
  background-color: #ebeef5 !important;
  /*opacity:0.1*/
}
/deep/.el-upload--text {
  height: 100%;
  width: 100%;
}
/deep/.el-upload-dragger {
  border: none;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.upload-select {
  margin-top: 10px;
  display: flex;
  align-items: center;
}
/deep/.uploadClass .el-dialog {
  border-radius: 0px !important;
  //height: 529px;
}
/deep/.el-upload-dragger:hover {
  color: #1f55c4;
  border-color: #1f55c4;
}
/deep/.el-upload-dragger.is-dragover {
  border: 2px dashed #1f55c4;
}
.el-select-dropdown__wrap ul li:last-child {
  margin-bottom: 0px !important;
}
</style>
